import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function Cookies() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-emerald-50">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Button variant="outline" onClick={() => navigate('/')} className="mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Ana Sayfaya Dön
        </Button>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-slate-800 mb-6">Çerez Politikası</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-lg text-slate-600 mb-6">
              <strong>Son Güncelleme:</strong> {new Date().toLocalizedString('tr-TR')}
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">1. Çerez Nedir?</h2>
            <p className="text-slate-700 mb-4">
              Çerezler, web sitelerinin tarayıcınızda sakladığı küçük metin dosyalarıdır.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">2. Kullanılan Çerezler</h2>
            <ul className="list-disc list-inside text-slate-700 space-y-2 mb-4">
              <li><strong>Zorunlu Çerezler:</strong> Oturum yönetimi, güvenlik</li>
              <li><strong>Performans Çerezleri:</strong> Analitik, platform performansı</li>
              <li><strong>Fonksiyonel Çerezler:</strong> Kullanıcı tercihleri, dil ayarları</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">3. Çerez Yönetimi</h2>
            <p className="text-slate-700 mb-4">
              Tarayıcı ayarlarınızdan çerezleri silebilir veya engelleyebilirsiniz. Ancak bu, 
              platformun bazı özelliklerinin çalışmamasına neden olabilir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}